import React from 'react';
import { match } from 'variant';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useExtensionDataClient } from '@wix/extensions-data-client';
import { SitePluginWizard } from './SitePluginWizard.js';

export const GenerateSitePlugin: React.FC = () => {
  const { t } = useTranslation();
  const { getWidgetPlugins } = useExtensionDataClient();

  const { status } = useAsync(getWidgetPlugins, []);

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner text={t('general.loading')} />,
    Success: ({ result }) => <SitePluginWizard widgetPlugins={result} />,
  });
};
